import { browserHistory } from 'react-router';
import UAHelper from 'fk-cp-common-components/utils/UAHelper';
import AppEnvironmentHelper from 'fk-cp-shared/utils/AppEnvironmentHelper.js';
import { extractProductDetailsFromUrl } from 'fk-cp-common-components/utils/miscUtils';

export const ERROR_TYPE = {
	COMPONENT_ERROR: 'ComponentError',
	GETAUTHPARAMS_BRIDGE_ERROR: 'GETAUTHPARAMS_BRIDGE_ERROR',
	PAGE_ERROR: 'PageError'
};

export function getQueriesFromURL() {
	return {
		queries: browserHistory.getCurrentLocation().query,
		pathname: browserHistory.getCurrentLocation().pathname || window.location.pathname,
		search: browserHistory.getCurrentLocation().search || window.location.search || window.location.href
	};
}

export function getComponentNameFromErrorStack(stack) {
	if (stack && typeof stack === 'string') {
		// Extract the component name from the first line of the stack trace
		const errorStackData = {};
		const stackInfo = stack.match(/at\s+(\w+)\s+\(/);
		//Extract the errortype and message from error stack
		const errorInfoRegex = /(\w+Error):\s(.+)/;
		const errInfo = errorInfoRegex.exec(stack);
		if (errInfo && errInfo.length) {
			errorStackData.errorType = errInfo[1];
			errorStackData.errorMessage = errInfo[2];
		} else {
			console.log('Unable to extract error type and error message.');
		}
		if (stackInfo && stackInfo.length) {
			// Return the captured component name
			errorStackData.FileName = stackInfo[1];
		}

		return errorStackData;
	}
	return null;
}

export function getError(message = '', errorType, data) {
	if (
		errorType === ERROR_TYPE.COMPONENT_ERROR ||
		errorType === ERROR_TYPE.PAGE_ERROR ||
		errorType === ERROR_TYPE.GETAUTHPARAMS_BRIDGE_ERROR
	) {
		return new Error(
			`[${data.isPage ? ERROR_TYPE.PAGE_ERROR : ERROR_TYPE.COMPONENT_ERROR}:${data.componentName}] => ${message}`
		);
	}
}

export default class NewRelicLogger {
	logErrorEvent = (data = {}, errorType = ERROR_TYPE.ERROR) => {
		const platform = UAHelper._getPlatform() || AppEnvironmentHelper.getPlatformString();
		let errorMessage = data.pageName || (window.location && window.location.href);

		if (data.errorMessage) {
			errorMessage += ' : ' + data.errorMessage;
		}
		if (data.request && data.request.method) {
			errorMessage = platform + ' ' + data.request.method + ' ' + errorMessage;
		}
		const errorObj = getError(errorMessage, errorType, data);
		const { errorData } = data;

		// Extract item_id, unit_id, and order_id from URL
		const productDetails = extractProductDetailsFromUrl();
		
		if (
			typeof window !== 'undefined' &&
			window.newrelic &&
			window.newrelic.noticeError &&
			errorType !== 'SS_API_ERROR'
		) {
			window.newrelic.noticeError(errorObj, {
				type: errorType,
				platform,
				currentPageUrl : (window.location && window.location.href) || '',
				errorStack: data.errorStack,
				errorMessage: data.errorMessage,
				componentName: data.componentName,
				actionName: data.actionName,
				urlDetails: data.urlDetails,
				transformerProvider: data.transformerProvider,
				networkInfo: this.buildRavenBody(),
				accId: window.localStorage.getItem('userAccID'),
				errorData,
				...productDetails
			});
		} else if (
			typeof window !== 'undefined' &&
			window.newrelic &&
			window.newrelic.noticeError &&
			errorType === 'SS_API_ERROR'
		) {
			window.newrelic.noticeError(errorObj, {
				type: errorType,
				networkInfo: this.buildRavenBody(),
				...data,
				...productDetails
			});
		}
	};

	/**
	 * @param actionName
	 * @attribute js object which will be available as `actionDetails` column in new relic
	 *
	 * Common function to send action events to new-relic.
	 * Ideal for scenarios where we want log UI behaviour.
	 * PageAction is document table name in new relic e.g ->'SELECT * FROM PageAction`*/
	logPageAction = (actionName, attribute) => {
		if (typeof window !== 'undefined' && window.newrelic && window.newrelic.addPageAction && typeof window.newrelic.addPageAction === 'function') {
			window.newrelic.addPageAction(actionName, { actionDetails: attribute });
		}
	};

	logCustomEvent = (data) => {
		if (typeof window !== 'undefined' && window.newrelic && window.newrelic.addPageAction && typeof window.newrelic.addPageAction === 'function') {
			const { type, ...rest } = data;
			window.newrelic.addPageAction(type, {...rest, platform: UAHelper._getPlatform()});
		}
	};

	setCustomAttribute = (attributeName, attributeValue) => {
		if(typeof window !== 'undefined' && window.newrelic && window.newrelic.setCustomAttribute && typeof window.newrelic.setCustomAttribute === 'function'){
			window.newrelic.setCustomAttribute(attributeName, attributeValue);
		}
	}
	
	/**
	 * @param {string} accountId - User account ID to set
	 * Sets user account ID as custom attribute in New Relic
	 */
	setUserAccountId = (accountId) => {
		if(typeof window !== 'undefined' && window.newrelic && window.newrelic.setCustomAttribute && typeof window.newrelic.setCustomAttribute === 'function' && typeof accountId === 'string'
		){
			try{
				window.newrelic.setCustomAttribute('accId', accountId);
			}
			catch(e){
				console.error('Failed to set user account id in New Relic', e);
			}
		}
	}

	buildRavenBody() {
		const body = Object.assign({});
		body.connectionType = navigator.connection ? navigator.connection.effectiveType : '';
		body.isOnline = navigator.onLine;
		return body;
	}
}
